import { Typography } from '@material-ui/core';
import { attributes, refTo } from '@type-r/models';
import { useIO, useLinked, useModel } from '@type-r/react';
import { Loading, Flex, Page, SearchInput, SelectSortBy, TilesList, Toolbar, div, SmallTile, PageContainer } from 'lqx-react';
import * as React from 'react';
import { fetchJson } from 'api/endpoint';
import { EditPermissions } from './edit-permissions';
import { UserMini } from './api';

const State = attributes({
    users: [UserMini],
    selected: refTo(UserMini),
    sortBy: {
        name: 'email',
        isAsc: false
    },
    filter: ''
})


export const UsersLandingPage = () => {
    const $filter = useLinked('');
    const state = useModel(State)


    const isReady = useIO(async () => {
        const users = await fetchJson('GET', "/api/inblock/tradetalk/v1/user");
        state.users.set(users);
    })
    
    const filtered = React.useMemo(() => {

        if (state.filter) {
            return state.users
            .filter(x => x.email.toLowerCase().includes(state.filter.toLowerCase()))
            .sort(UserMini.comparator(state.sortBy.name as any, state.sortBy.isAsc))
        }

        return state.users.models.sort(UserMini.comparator(state.sortBy.name as any, state.sortBy.isAsc))

    }, [state.filter, state.sortBy['_changeToken'], state.users['_changeToken']]);

    return isReady ?
        <PageContainer>
            <Page
                menuWidth={530}
                maxWidth="xl"
                left={
                    <>
                        <Toolbar>
                            <SearchInput
                                $value={state.$.filter}
                                placeholder="Filter by email"
                            />
                            <SelectSortBy
                                $attr={state.sortBy.$.name}
                                $asc={state.sortBy.$.isAsc}
                                options={sortSummaryOptions}
                            />
                        </Toolbar>
                        <VerticalSpace />

                        {!isReady ?
                            <Loading />
                            :
                            filtered.length ?
                                <TilesList
                                    items={filtered}
                                    itemSize={64}
                                    renderer={UserMiniTile(state.$.selected)}
                                    selectedItem={state.selected}
                                />
                                :
                                <Flex center stretch>
                                    <Typography variant="h4">No results found.</Typography>
                                </Flex>
                        }
                    </>
                }>
                {state.selected ? <EditPermissions user={state.selected} />
                    : <Flex center stretch>
                        Select the customer
                    </Flex>
                }
            </Page>
        </PageContainer>
        :
        <Loading />
}

const sortSummaryOptions = {
    email: 'email'
};


const VerticalSpace = div({
    height: 8
})

const UserMiniTile = $selected => ({ data, style, index }) => {
    const user = data.items[index] as UserMini;

    return (
        <div style={style}>
            <SmallTile
                color={'green'}
                isSelected={$selected.value === user}

                onClick={e => {
                    $selected.set(user);
                }}

                footer={
                    <>
                        <div>{user.email}</div>
                    </>
                }
            >
                {user.firstName} {user.lastName}
            </SmallTile>
        </div>
    )
}

async function getRoles() {
    return await fetchJson('GET', `/api/inblock/tradetalk/v1/role`);
}
